import styled from "@emotion/styled";
import { Color } from "../../../../Theme";
var StyledLabel = /*#__PURE__*/ styled("label", {
    target: "ehownyx0"
})("display:inline-flex;column-gap:0.5rem;cursor:pointer;user-select:none;");
// screen reader only
var StyledCheckbox = /*#__PURE__*/ styled("input", {
    target: "ehownyx1"
})("position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;");
var CheckboxWrapper = /*#__PURE__*/ styled("span", {
    target: "ehownyx2"
})("display:inline-flex;align-items:center;justify-content:center;background-color:", Color.natural0, ";border:1px solid\n    ", function(props) {
    return props.isChecked ? Color.primary : Color.natural50;
}, ";width:1.25rem;height:1.25rem;padding:0.1875rem;outline:0;svg{fill:", function(props) {
    return props.isChecked ? Color.primary : "inherit";
}, ";}");
export { StyledLabel, StyledCheckbox, CheckboxWrapper };
